// extracted by mini-css-extract-plugin
module.exports = {"viewDownloadsModalWrapper":"yE","header":"yF","headline":"yG","closeIcon":"yH","modalCloseIcon":"yI"};